// extracted by mini-css-extract-plugin
export var addWidgetButton = "_w-6";
export var backButton = "_w-1";
export var legacyWidgetContainer = "_w-5";
export var pageContainer = "_w-2";
export var settingsContent = "_w-0";
export var widgetSubsectionItem = "_w-3";
export var widgetSubsectionItemContent = "_w-4";